import type { Estimate, PdfDocument } from '@/types/estimate';

type EstimateMessageFields = Pick<
  Estimate,
  'notes' | 'renderedNotes' | 'status' | 'customerApprovalMethod'
>;

export function getEstimateCustomerNotes(
  estimate: Pick<Estimate, 'notes' | 'renderedNotes'>,
): string {
  return estimate.renderedNotes ?? estimate.notes ?? '';
}

export function canUseStoredEstimatePdf(
  estimate: EstimateMessageFields,
  activePdf?: (Pick<PdfDocument, 'reason'> & { url?: string | null }) | null,
): boolean {
  if (!activePdf?.url) return false;

  const hasRenderedTemplate =
    estimate.renderedNotes != null && estimate.renderedNotes !== estimate.notes;
  if (!hasRenderedTemplate) return true;

  // New PDFs record how they were created and always use renderedNotes.
  if (activePdf.reason === 'generated' || activePdf.reason === 'signature_collected') {
    return true;
  }

  // Preserve legacy signed PDFs as immutable legal artifacts. Other legacy
  // PDFs with dynamic notes are regenerated so raw placeholders cannot leak.
  return (
    (estimate.status === 'APPROVED' || estimate.status === 'CONVERTED') &&
    estimate.customerApprovalMethod === 'SIGNATURE'
  );
}
